import React, { useState } from "react";
import { CentralAjudaService } from "../../../services/CentralAjudaService";
import { AtendimentoType } from "../../../types/AtendimentoType";

export function ChatHistorico(){
  const [loading, setLoading] = useState(false);
  const [atendimentos, setAtendimentos] = useState([] as AtendimentoType[])

  const getChatContent = () => {
    setLoading(true);
      CentralAjudaService.atendimento.buscarAtendimentosPorSlug('central_ajuda')
      .then(response => {
          setLoading(false);
          if(response.data.data.data.length > 0 && response.status === 200){
              setAtendimentos(response.data.data.data);
          }
      })
      .catch(erro => {
        setLoading(false)
      });
  };

  return (
    <div>
      Mensagens

    </div>
  )
}
